var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGeneral = function SvgGeneral(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56182 8.42374C2.52318 8.46637 2.48992 8.53619 2.50276 8.64573L3.48185 16.9936C3.51219 17.2523 3.77964 17.5001 4.07153 17.5001H15.9284C16.2189 17.5001 16.488 17.2497 16.518 16.9936L17.4971 8.64573C17.5103 8.53375 17.4763 8.46466 17.4387 8.42326C17.3998 8.38053 17.3252 8.33341 17.1972 8.33341H2.80269C2.67555 8.33341 2.60116 8.38034 2.56182 8.42374ZM0.847444 8.83987C0.707039 7.64275 1.61486 6.66675 2.80269 6.66675H17.1972C18.3804 6.66675 19.2937 7.6355 19.1525 8.83987L18.1734 17.1878C18.0424 18.3043 17.0431 19.1667 15.9284 19.1667H4.07153C2.95886 19.1667 1.95818 18.3103 1.82653 17.1878L0.847444 8.83987Z",
    fill: "#082244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33334 4.58333C3.33334 4.1231 3.70644 3.75 4.16668 3.75H15.8333C16.2936 3.75 16.6667 4.1231 16.6667 4.58333C16.6667 5.04357 16.2936 5.41667 15.8333 5.41667H4.16668C3.70644 5.41667 3.33334 5.04357 3.33334 4.58333Z",
    fill: "#082244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41666 1.66671C5.41666 1.20647 5.78975 0.833374 6.24999 0.833374H13.75C14.2102 0.833374 14.5833 1.20647 14.5833 1.66671C14.5833 2.12694 14.2102 2.50004 13.75 2.50004H6.24999C5.78975 2.50004 5.41666 2.12694 5.41666 1.66671Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGeneral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general.14369b57.svg";
export { ForwardRef as ReactComponent };